import { DEFAULT_ENDPOINT_LIMIT } from "PFApp/constants/api_limits";
import { Flex, Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { ReactNode } from "react";

type PageEntriesCounterProps = {
  count: number;
  loading?: boolean;
  limitThreshold?: number;
  label: string;
  labelWithLimit?: string;
  limitMessage?: string | ReactNode;
  classes?: {
    root?: string;
    label?: string;
  };
  clipOverflow?: boolean;
};

export const PageEntriesCounter = ({
  count,
  loading = false,
  limitThreshold = DEFAULT_ENDPOINT_LIMIT,
  label,
  labelWithLimit,
  limitMessage,
  classes,
  clipOverflow
}: PageEntriesCounterProps) => {
  if (loading) {
    return null;
  }

  const isLimitReached = count >= limitThreshold;
  const displayLabel = isLimitReached && labelWithLimit ? labelWithLimit : label;
  const withInfoIcon = isLimitReached && limitMessage;

  return (
    <Inline alignItems="center" gap="spacingXs" className={classes?.root}>
      {withInfoIcon && (
        <Tooltip tooltipContainerProps={{ style: { maxWidth: 400 } }} content={limitMessage}>
          {({ ref, getReferenceProps }) => (
            <Flex center ref={ref} {...getReferenceProps()}>
              <Icon name="info" color="paletteBlue2" />
            </Flex>
          )}
        </Tooltip>
      )}
      <Typography variant="labelRegular" clipOverflow={clipOverflow} className={classes?.label}>
        {displayLabel}
      </Typography>
    </Inline>
  );
};
